import {ModalBackdrop} from 'common/components/modal_backdrop';
import {UnlockInterviewGuideModalContent} from 'iq-upselling/components/unlock_interview_guide_modal_content';

interface UnlockInterviewGuideProps {
  company: string;
  totalCount: number;
  onClose: () => void;
  onShare: () => void;
}

export default function UnlockInterviewGuide({onClose, onShare}: UnlockInterviewGuideProps) {
  return (
    <ModalBackdrop onClose={onClose} zIndex={20}>
      <UnlockInterviewGuideModalContent onShare={onShare} />
    </ModalBackdrop>
  );
}
